/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DivideCircleIcon64Regular = forwardRef('DivideCircleIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M19 30.5a1.5 1.5 0 0 0 0 3h26a1.5 1.5 0 0 0 0-3H19Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27 21a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 38a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-2 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 6C17.64 6 6 17.64 6 32s11.64 26 26 26 26-11.64 26-26S46.36 6 32 6ZM9 32C9 19.297 19.297 9 32 9s23 10.297 23 23-10.297 23-23 23S9 44.703 9 32Z" })));
});
